import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LogDetailsComponent} from './components/admin/logs/log-details/log-details.component';
import {LogsComponent} from './components/admin/logs/logs.component';
import {AnnouncementPageComponent} from './components/announcement-page/announcement-page.component';
import {ConsentFormComponent} from './components/consents/consent-form/consent-form.component';
import {CustomFormDisplayComponent} from './components/custom-form-display/custom-form-display.component';
import {
  CustomFormParentDisplayComponent
} from './components/custom-form-parent-display/custom-form-parent-display.component';
import {GeneralEmailComponent} from './components/dialogs/general-email/general-email.component';
import {FeaturesSectionComponent} from './components/features-section/features-section.component';
import {HomeComponent} from './components/home/home.component';
import {MobileHistoryComponent} from './components/home/homeComponents/mobile-history/mobile-history.component';
import {MobileSearchComponent} from './components/home/homeComponents/mobile-search/mobile-search.component';
import {
  ChildHistoryConsentsComponent
} from './components/home/mobileLayout/child-history-consents/child-history-consents.component';
import {ParentConsentsComponent} from './components/home/mobileLayout/parent-consents/parent-consents.component';
import {
  ParentPersonalMessagesComponent
} from './components/home/mobileLayout/parent-personal-messages/parent-personal-messages.component';
import {
  CompleteAffirmationDialogComponent
} from './components/home/parent-affirmations/complete-affirmation-dialog/complete-affirmation-dialog.component';
import {InitializeFormComponent} from './components/initialize-form/initialize-form.component';
import {LoginAttemptsComponent} from './components/login-attempts/login-attempts.component';
import {LoginComponent} from './components/login/login.component';
import {MyAffirmationsComponent} from './components/my-affirmations/my-affirmations.component';
import {PublicFormDisplayComponent} from './components/public-form-display/public-form-display.component';
import {
  AffirmationReportDetailsComponent
} from './components/reports/affirmation-report-details/affirmation-report-details.component';
import {
  CustomFormParentCompletedComponent
} from './components/reports/custom-form-parent-reports/custom-form-parent-completed/custom-form-parent-completed.component';
import {
  CustomFormCompletedComponent
} from './components/reports/custom-form-reports/custom-form-completed/custom-form-completed.component';
import {ReportDetailsComponent} from './components/reports/report-details/report-details.component';
import {ReportsComponent} from './components/reports/reports.component';
import {
  ActivitiesDialogComponent
} from './components/settings/affirmations/activities-dialog/activities-dialog.component';
import {
  ActivitiesLevelsDialogComponent
} from './components/settings/affirmations/activities-levels-dialog/activities-levels-dialog.component';
import {AffirmationsComponent} from './components/settings/affirmations/affirmations.component';
import {
  CreateActivityDialogComponent
} from './components/settings/affirmations/create-activity-dialog/create-activity-dialog.component';
import {CollegeManagementComponent} from './components/settings/college-management/college-management.component';
import {
  ConsentQuestionManagementComponent
} from './components/settings/consent-question-management/consent-question-management.component';
import {EmailLogsComponent} from './components/settings/email-logs/email-logs.component';
import {FormCreatorComponent} from './components/settings/form-creator/form-creator.component';
import {FormsComponent} from './components/settings/forms/forms.component';
import {ParentsListComponent} from './components/settings/parents-list/parents-list.component';
import {
  RoleActionManagementComponent
} from './components/settings/role-action-management/role-action-management.component';
import {SettingsComponent} from './components/settings/settings.component';
import {SmsLogsComponent} from './components/settings/sms-logs/sms-logs.component';
import {StaffComponent} from './components/settings/staff/staff.component';
import {StudentsListComponent} from './components/settings/students-list/students-list.component';
import {
  TempCustomFormCreatorComponent
} from './components/settings/temp-custom-form-creator/temp-custom-form-creator.component';
import {
  AiFormCreatorComponent
} from './components/settings/ai-form-creator/ai-form-creator.component';
import {UserConfirmationComponent} from './components/settings/user-confirmation/user-confirmation.component';
import {UserSettingsComponent} from './components/settings/user-settings/user-settings.component';
import {AnnouncementsDisplayComponent} from './components/shared/announcements/announcements-display.component';
import {FormSuccessComponent} from './components/shared/form-success/form-success.component';
import {HeaderLayoutComponent} from './components/shared/header-layout/header-layout.component';
import {MessageComponent} from './components/shared/message/message.component';
import {LoginGuardService} from './guards/login-guard.service';
import {NavigationGuardService} from './guards/navigation-guard.service';
import {PrivilegesGuard} from './guards/privileges.guard';
import {
  ParentStudentRegistrationComponent
} from './components/parent-student-registration/parent-student-registration.component';
import {ResumesComponent} from './components/resumes/resumes/resumes.component';
import {ResumesEditorComponent} from './components/resumes/resumes/resumes-editor/resumes-editor.component';
import {ResumesQuestionsComponent} from './components/resumes/resumes/resumes-questions/resumes-questions.component';
import {
  ResumeReportDetailsComponent
} from './components/reports/resume-reports/resume-report-details/resume-report-details.component';
import {ResumeFormComponent} from './components/resumes/resume-form/resume-form.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  },
  {
    component: LoginComponent,
    path: 'login',
    // canActivate: [LoginGuardService]
  },
  {
    path: 'resume-form',
    component: ResumeFormComponent
  },
  {
    component: InitializeFormComponent,
    path: 'initialize',
    // canActivate: [LoginGuardService]
  },
  {
    path: 'registration',
    component: ParentStudentRegistrationComponent
  },
  {
    path: 'publicForm',
    component: PublicFormDisplayComponent
  },
  {
    path: 'requestFrom',
    canActivate: [LoginGuardService],
    component: CustomFormDisplayComponent
  },
  {
    path: 'parentRequestForm',
    canActivate: [LoginGuardService],
    component: CustomFormParentDisplayComponent
  },
  {
    path: 'consentForm',
    canActivate: [LoginGuardService],
    component: ConsentFormComponent
  },
  {
    path: 'complete-affirmation',
    canActivate: [LoginGuardService],
    component: CompleteAffirmationDialogComponent
  },
  {
    path: 'success',
    component: FormSuccessComponent
  },
  {
    component: HeaderLayoutComponent,
    path: 'home',
    canActivate: [NavigationGuardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/home/main'
      },
      {
        path: 'main',
        component: HomeComponent
      },
      {
        path: 'email',
        component: GeneralEmailComponent
      },
      {
        path: 'form-creator',
        component: FormCreatorComponent
      },
      {
        path: 'resume-creator',
        component: ResumesEditorComponent
      },
      {
        path: 'resume-form-i',
        component: ResumeFormComponent
      },
      {
        path: 'resume-report-details',
        component: ResumeReportDetailsComponent
      },
      {
        path: 'resume-fields',
        component: ResumesQuestionsComponent
      },
      {
        path: 'mobile-parent-consents',
        component: ParentConsentsComponent
      },
      {
        path: 'mobile-child-history-consents',
        component: ChildHistoryConsentsComponent
      },
      {
        path: 'mobile-parent-messages',
        component: ParentPersonalMessagesComponent
      },
      // {
      //   path: 'custom-form-creator',
      //   component: CustomFormCreatorComponent
      // },
      {
        path: 'custom-form-creator',
        component: TempCustomFormCreatorComponent
      },
      {
        path: 'ai-form-creator',
        component: AiFormCreatorComponent
      },
      {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [PrivilegesGuard],
      },
      {
        path: 'forms',
        component: FormsComponent,
        canActivate: [PrivilegesGuard],
      },
      {
        path: 'search',
        component: MobileSearchComponent
      },
      {
        path: 'mobile-history',
        component: MobileHistoryComponent
      },
      {
        path: 'requestFrom',
        canActivate: [LoginGuardService],
        component: CustomFormDisplayComponent
      },
      {
        path: 'parentRequestForm',
        canActivate: [LoginGuardService],
        component: CustomFormParentDisplayComponent
      },
      {
        path: 'publicRequestForm',
        component: PublicFormDisplayComponent
      },
      {
        path: 'parents',
        component: ParentsListComponent,
        canActivate: [PrivilegesGuard],
      },
      {
        path: 'staff',
        component: StaffComponent,
        canActivate: [PrivilegesGuard],
      },
      {
        path: 'students',
        component: StudentsListComponent,
        canActivate: [PrivilegesGuard],
      },
      {
        path: 'resumes',
        component: ResumesComponent,
        canActivate: [PrivilegesGuard],
      },
      {
        path: 'roles-management',
        component: RoleActionManagementComponent
      },
      {
        path: 'message/:id',
        component: MessageComponent
      },
      {
        path: 'consents-questions',
        component: ConsentQuestionManagementComponent
      },
      {
        path: 'college-management',
        component: CollegeManagementComponent
      },
      {
        path: 'affirmations',
        component: AffirmationsComponent
      },
      {
        path: 'activities',
        component: ActivitiesDialogComponent
      },
      {
        path: 'activities-level',
        component: ActivitiesLevelsDialogComponent
      },
      {
        path: 'my-affirmations',
        component: MyAffirmationsComponent
      },
      {
        path: 'email-logs',
        component: EmailLogsComponent
      },
      {
        path: 'sms-logs',
        component: SmsLogsComponent
      },
      {
        path: 'affirmation-creator',
        component: CreateActivityDialogComponent
      },
      {
        path: 'complete-affirmation',
        component: CompleteAffirmationDialogComponent
      },
      {
        path: 'affirmation-report-details',
        component: AffirmationReportDetailsComponent
      },
      {
        path: 'logs',
        component: LogsComponent
      },
      {
        path: 'user-confirmation',
        component: UserConfirmationComponent
      },
      {
        path: 'log-details',
        component: LogDetailsComponent
      },
      {
        path: 'features',
        component: FeaturesSectionComponent
      },
      {
        path: 'consentForm',
        canActivate: [LoginGuardService],
        component: ConsentFormComponent
      },

      {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [PrivilegesGuard],
      },
      {
        path: 'login-attempts',
        component: LoginAttemptsComponent
      },
      {
        path: 'completed-forms-details',
        canActivate: [LoginGuardService],
        component: CustomFormCompletedComponent
      },
      {
        path: 'completed-parent-forms-details',
        canActivate: [LoginGuardService],
        component: CustomFormParentCompletedComponent
      },
      {
        path: 'announcement',
        component: AnnouncementsDisplayComponent
      },
      {
        path: 'announcement-page',
        component: AnnouncementPageComponent
      },
      {
        path: 'user-settings',
        component: UserSettingsComponent
      },
      {
        path: 'report-details',
        component: ReportDetailsComponent
      },
    ]
    // canActivateChild: [NavigationGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
